import { render } from "./ProfessionDirectionsView.vue?vue&type=template&id=754b136f&scoped=true"
import script from "./ProfessionDirectionsView.vue?vue&type=script&lang=js"
export * from "./ProfessionDirectionsView.vue?vue&type=script&lang=js"

import "./ProfessionDirectionsView.vue?vue&type=style&index=0&id=754b136f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754b136f"]])

export default __exports__